<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <div v-if="loading" class="loading-mask">
        <div class="spinner"></div>
        <div class="loading-text">加载中...</div>
    </div>

    <div v-else class="page-container">
        <div class="page-header">
            <div class="header-top">
                <div class="top-title" @click="clickTitle">我的数字员工</div>
                <div>
                    <a-input-search
                        v-model:value="searchVal"
                        placeholder="搜索"
                        style="width: 300px; border-radius: 8px"
                        allow-clear
                        @search="onSearch"
                        @change="searchChange"
                    />
                </div>
            </div>
            <div class="header-bottom">
                <div class="header-bottom-left">
                    <div class="header-label">
                        <div
                            :class="{
                                'bottom-item': true,
                                'bottom-item-active':
                                    item.id === activeClassId &&
                                    searchFlag === false,
                                'bottom-item-active-search':
                                    item.id === activeClassId &&
                                    searchFlag === true,
                            }"
                            @click="scrollToSection(item)"
                            v-for="item in state.classTypes || []"
                            :key="item.id"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div class="header-bottom-right">
                    <a-button-group class="share-type-group">
                        <a-button
                            title="本人创建的数字员工"
                            :class="{ 'share-btn-active': shareTab === '本人' }"
                            @click="selectShareTab('本人')"
                        >
                            本人
                        </a-button>
                        <a-button
                            title="他人共享给我的数字员工"
                            :class="{
                                'share-btn-active': shareTab === '共享',
                            }"
                            @click="selectShareTab('共享')"
                        >
                            共享
                        </a-button>
                    </a-button-group>
                </div>
            </div>

            <template v-if="searchFlag">
                <div class="page-content">
                    <MarketCards
                        :searchStr="searchStr"
                        :classType="activeClass"
                        :load-more="true"
                        :shareType="shareTab"
                    />
                </div>
            </template>
            <template v-else>
                <!-- 首页 -->
                <div
                    class="page-content"
                    v-for="idx in state.classTypes"
                    :key="idx.id"
                >
                    <div
                        v-if="state.allData?.dataTable?.[idx.name]?.length > 0"
                        class="content-title"
                        @click="changeTags(idx.id, idx.name)"
                        :id="idx.sectionId"
                        :style="{ 'scroll-margin-top': '100px' }"
                    >
                        {{ idx.name }}
                        <i>
                            <RightOutlined />
                        </i>
                        <span style="color: #c0c4cc; font-size: 16px"
                            >更多...</span
                        >
                    </div>
                    <div
                        class="content-cards"
                        v-if="state.allData?.dataTable?.[idx.name]?.length > 0"
                    >
                        <div
                            class="cards-item"
                            v-for="(item, index) in state.allData.dataTable[
                                idx.name
                            ]"
                            :key="item.Id"
                            :style="{
                                backgroundColor:
                                    item.IsHidden == '1' ? '#f5f5f5' : '#fff',
                            }"
                        >
                            <span class="fan-num">{{ index + 1 }}</span>

                            <div class="item-left">
                                <img :src="item.photo" alt="" />
                            </div>
                            <div class="item-right">
                                <div class="__header">
                                    <!-- 👇 图标按钮 -->
                                    <div
                                        v-if="
                                            item.realPlatform == 'PT001' ||
                                            item.realPlatform == 'PT002' ||
                                            item.realPlatform == 'PT005'
                                        "
                                        class="__toggle"
                                        @click="toggleVisible(item)"
                                    >
                                        <img
                                            :src="
                                                item.IsHidden == '0'
                                                    ? require('@/static/images/icon/eye.png')
                                                    : require('@/static/images/icon/eye-off.png')
                                            "
                                            class="icon-img"
                                        />
                                    </div>
                                    <div
                                        :class="
                                            item.PubState
                                                ? item.PubState === '测试'
                                                    ? 'badge badge-test'
                                                    : 'badge badge-prod'
                                                : ''
                                        "
                                    >
                                        {{ item.PubState }}
                                    </div>
                                    <div class="__deployType">
                                        {{ item.realPlatformName }}
                                    </div>
                                    <div class="__local">
                                        {{ item.deployType }}
                                    </div>
                                    <div class="__status">
                                        {{ item.shareType }}
                                    </div>
                                </div>

                                <div class="__title">
                                    {{ item.ProcessID }}
                                </div>
                                <div class="__content">
                                    {{ item.ProcessName }}
                                </div>
                                <div class="__label">
                                    机器人:{{ item.RobotName }}
                                </div>
                                <div class="__status">
                                    状态:
                                    <span
                                        class="status"
                                        :class="
                                            item.RunStatus === '运行中'
                                                ? 'status-running'
                                                : 'status-idle'
                                        "
                                    >
                                        {{ item.RunStatus }}
                                    </span>
                                </div>

                                <div class="__bottom">
                                    <div title="开发者">
                                        @{{ item.CreateMan }}
                                    </div>
                                    <div title="累计执行次数（所有人）">
                                        <svg
                                            t="1765937449042"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="35589"
                                            width="12"
                                            height="12"
                                        >
                                            <path
                                                d="M144.06514 817.808918l769.31546 0 0 63.513546-769.31546 0 0-63.513546Z"
                                                fill="#CCCCCC"
                                                p-id="35590"
                                            ></path>
                                            <path
                                                d="M143.416364 109.250216l63.557548 0 0 764.188696-63.557548 0 0-764.188696Z"
                                                fill="#CCCCCC"
                                                p-id="35591"
                                            ></path>
                                            <path
                                                d="M492.728074 197.891046l63.557548 0 0 586.90499-63.557548 0 0-586.90499Z"
                                                fill="#CCCCCC"
                                                p-id="35592"
                                            ></path>
                                            <path
                                                d="M684.330904 347.398128l63.557548 0 0 437.397908-63.557548 0 0-437.397908Z"
                                                fill="#CCCCCC"
                                                p-id="35593"
                                            ></path>
                                            <path
                                                d="M301.254182 495.28634l63.557548 0 0 289.509696-63.557548 0 0-289.509696Z"
                                                fill="#CCCCCC"
                                                p-id="35594"
                                            ></path>
                                        </svg>
                                        {{ item.useTimes }}
                                    </div>

                                    <div title="上岗时间">
                                        <svg
                                            t="1765937375819"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="27704"
                                            width="12"
                                            height="12"
                                        >
                                            <path
                                                d="M512 42.666667c259.2 0 469.333333 210.133333 469.333333 469.333333s-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667z m0 85.333333a384 384 0 1 0 0 768 384 384 0 0 0 0-768z"
                                                fill="#C2C5CC"
                                                p-id="27705"
                                            ></path>
                                            <path
                                                d="M512 256a42.666667 42.666667 0 0 1 42.666667 42.666667v256a42.666667 42.666667 0 0 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z"
                                                fill="#C2C5CC"
                                                p-id="27706"
                                            ></path>
                                            <path
                                                d="M768 512m0 42.666667l0 0q0 42.666667-42.666667 42.666666l-213.333333 0q-42.666667 0-42.666667-42.666666l0 0q0-42.666667 42.666667-42.666667l213.333333 0q42.666667 0 42.666667 42.666667Z"
                                                fill="#C2C5CC"
                                                p-id="27707"
                                            ></path></svg
                                        >{{ item.AuditTime }}
                                    </div>
                                    <div
                                        title="排序"
                                        v-if="
                                            item.realPlatform == 'PT001' ||
                                            item.realPlatform == 'PT002' ||
                                            item.realPlatform == 'PT005'
                                        "
                                    >
                                        <svg
                                            t="1768273934486"
                                            class="icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            p-id="6892"
                                            width="12"
                                            height="12"
                                        >
                                            <path
                                                d="M449.92 101.888a38.4 38.4 0 0 1 60.16 0l225.28 283.84a38.4 38.4 0 0 1-30.08 62.272H254.72a38.4 38.4 0 0 1-30.08-62.272l225.28-283.84z"
                                                fill="#5089F6"
                                                p-id="6893"
                                            ></path>
                                            <path
                                                d="M449.92 922.112a38.4 38.4 0 0 0 60.16 0l225.28-283.84A38.4 38.4 0 0 0 705.28 576H254.72a38.4 38.4 0 0 0-30.08 62.272l225.28 283.84z"
                                                fill="#C2C7CC"
                                                p-id="6894"
                                            ></path>
                                        </svg>
                                        {{ item.seq }}
                                    </div>
                                </div>
                                <div class="icon-btn-group">
                                    <div
                                        v-for="act in actions"
                                        :key="act.key"
                                        class="icon-btn"
                                        :title="act.title"
                                        :class="{
                                            disabled:
                                                item.RunStatus != '空闲中' &&
                                                act.key == 'run',
                                        }"
                                        @click="
                                            () => {
                                                if (
                                                    item.RunStatus ==
                                                        '空闲中' &&
                                                    act.key == 'run'
                                                ) {
                                                    act.onClick(item);
                                                    return;
                                                }
                                                if (act.key != 'run') {
                                                    act.onClick(item);
                                                    return;
                                                }
                                            }
                                        "
                                    >
                                        <img
                                            v-if="
                                                act.key == 'run' &&
                                                (item.realPlatform == 'PT003' ||
                                                    item.realPlatform ==
                                                        'PT004')
                                            "
                                            :src="act.jumpIcon"
                                            :alt="act.title"
                                        />
                                        <img
                                            v-else-if="
                                                act.key == 'run' &&
                                                (item.realPlatform == 'PT001' ||
                                                    item.realPlatform ==
                                                        'PT002' ||
                                                    item.realPlatform ==
                                                        'PT005') &&
                                                item.RunStatus == '空闲中' &&
                                                item.deployType == '平台'
                                            "
                                            :src="act.icon"
                                            :alt="act.title"
                                        />
                                        <img
                                            v-else-if="
                                                act.key == 'run' &&
                                                (item.realPlatform == 'PT001' ||
                                                    item.realPlatform ==
                                                        'PT002' ||
                                                    item.realPlatform ==
                                                        'PT005') &&
                                                item.RunStatus != '空闲中'
                                            "
                                            :src="act.stopIcon"
                                            :alt="act.title"
                                        />
                                        <img
                                            v-else-if="
                                                act.key == 'run' &&
                                                (item.realPlatform == 'PT006' ||
                                                    item.realPlatform ==
                                                        'PT005') &&
                                                item.RunStatus == '空闲中' &&
                                                item.deployType == '本地'
                                            "
                                            :src="act.runIconLocal"
                                            :alt="act.title"
                                        />
                                        <img
                                            v-else-if="act.key != 'run'"
                                            :src="act.icon"
                                            :alt="act.title"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 回到顶部按钮 -->
        <div v-if="showBackTop" class="back-top" @click="scrollToTop">↑</div>
    </div>

    <runlog ref="runlogRef" />
    <runlogPython ref="runlogpythonRef" />
    <runlogLocal ref="runlogLocalRef" />
    <dempSetup ref="dempSetupRef" @flashData="getDEmpListApi" />
    <dempotherSetup ref="dempotherSetupRef" @flashData="getDEmpListApi" />
    <dempPythonSetup ref="dempPythonSetupRef" @flashData="getDEmpListApi" />
</template>

<script setup>
import {
    reactive,
    ref,
    onMounted,
    onUnmounted,
    watch,
    getCurrentInstance,
} from "vue";

import { RightOutlined } from "@ant-design/icons-vue";
import { debounce } from "lodash";
import MarketCards from "./marketcards.vue";
import runIcon from "@/static/images/icon/play.png";
import runIconLocal from "@/static/images/icon/localplay.png";
import settingIcon from "@/static/images/icon/setting.png";
import logIcon from "@/static/images/icon/log.png";
import jumpIcon from "@/static/images/icon/jump.png";
import stopIcon from "@/static/images/icon/stop.png";
import { VXETable } from "vxe-table";
import Qs from "qs";
import runlog from "./runlog.vue";
import runlogPython from "./runlogPython.vue";
import runlogLocal from "./runlogLocal.vue";
import dempSetup from "./dempSetup.vue";
import dempotherSetup from "./dempotherSetup.vue";
import dempPythonSetup from "./demppythonSetup.vue";

const { proxy } = getCurrentInstance();

let searchVal = ref(""); // 搜索框的值
let activeClassId = ref(); //选中的类别
let searchFlag = ref(false); // 搜索框是否显示
let searchStr = ref(""); // 搜索字符串
const loading = ref(true);
const runlogRef = ref(null);
const runlogpythonRef = ref(null);
const runlogLocalRef = ref(null);
const dempSetupRef = ref(null);
const dempotherSetupRef = ref(null);
const dempPythonSetupRef = ref(null);
const showBackTop = ref(false);
const shareTab = ref("本人");
const selectShareTab = (type) => {
    shareTab.value = shareTab.value === type ? "" : type;
    if (activeClassId.value == null && searchStr.value == "") {
        getDEmpListApi();
    }
};

const scrollToTop = () => {
    const el = document.querySelector(".app-layout__page");

    if (!el) {
        return;
    }

    el.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};

const onSearch = () => {
    console.log("搜索框的值：", searchVal.value);
    if (searchVal.value) {
        searchFlag.value = true; // 显示搜索结果
        searchStr.value = searchVal.value; // 设置搜索字符串
    } else {
        searchFlag.value = false; // 显示搜索结果
        searchStr.value = ""; // 设置搜索字符串
    }
};

const searchChange = debounce(() => {
    console.log("搜索框的值111：", searchVal.value);
    if (searchVal.value) {
        searchFlag.value = true; // 显示搜索结果
        searchStr.value = searchVal.value; // 设置搜索字符串
    } else {
        searchStr.value = ""; // 清空搜索字符串
        if (activeClassId.value == null) {
            searchFlag.value = false; // 隐藏搜索结果
        }
    }
}, 1000);

const state = reactive({
    classTypes: [],
    allData: {},
});

let activeClass = ref(); //选中的类型

console.log(`activeClass${activeClass.value}`);
const changeTags = (id, name) => {
    activeClassId.value = id;
    activeClass.value = name;
    console.log("选中的类型ID：", id, "选中的类型名称：", name);
    searchFlag.value = true;
};
const addJobsLocal = (
    processID,
    processName,
    localAppPath,
    localAppType,
    localExeFile,
    localExeParam
) => {
    const params = {
        ProcessID: processID,
        ProcessName: processName,
        CreatorUserId: proxy.$store.state.email,
        localAppPath: localAppPath,
        localAppType: localAppType,
        localExeFile: localExeFile,
        localExeParam: localExeParam,
    };
    proxy.$api.dEmpAPI
        .addJobLocal(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const execLocalFile = async (
    ProcessID,
    ProcessName,
    localAppPath,
    localAppType,
    localExeFile,
    localExeParam
) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        let safeProtocolName = "coe" + ProcessID;
        const params = localExeParam;
        if (!ProcessID?.trim()) {
            VXETable.modal.message({
                content: "请输入协议名称！",
                status: "error",
            });
            return;
        }
        const link =
            localExeParam != ""
                ? `${safeProtocolName}://${params || ""}`
                : `${safeProtocolName}://`;
        const a = document.createElement("a");
        a.href = link;
        a.click();
        addJobsLocal(
            ProcessID,
            ProcessName,
            localAppPath,
            localAppType,
            localExeFile,
            localExeParam
        );
    }
};
const playProcess = async (pId, item) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            actionType: "1",
            actionKey: [pId, proxy.$store.state.userName],
        };
        proxy.$api.jobManageAPI
            .startProcess(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                // console.log(res.data.Data);
                VXETable.modal.message({
                    content: "流程已提交执行,请勿重复操作!",
                    status: "warning",
                });
                item.RunStatus = "排队中";
            })
            .catch((error) => {
                console.log(error);
            });
    }
};
const playProcessPython = async (pId, item) => {
    const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
    if (type === "confirm") {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            actionType: "1",
            actionKey: [pId, proxy.$store.state.userName],
        };
        proxy.$api.jobManageAPI
            .startProcessPython(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                // console.log(res.data.Data);
                VXETable.modal.message({
                    content: "Python流程已提交执行,请勿重复操作!",
                    status: "warning",
                });
                item.RunStatus = "排队中";
            })
            .catch((error) => {
                console.log(error);
            });
    }
};

// 执行日志接口 addDigitalEmpLogs
const addDigitalEmpLogsApi = (params) => {
    proxy.$api.dashboardAPI
        .addDigitalEmpLogs(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success) {
                console.log("执行日志添加成功");
            } else {
                console.log("执行日志添加失败");
            }
        });
};

const run = (item) => {
    console.log(item);
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        playProcess(item.Id, item);
    } else if (item.realPlatform == "PT003") {
        //dify
        if (item.otherPlatform) {
            // 执行日志接口
            addDigitalEmpLogsApi({
                PubID: item.Id,
                UserID: proxy.$store.state.userID,
                Type: "1",
            });
            window.open(item.otherPlatform, "_blank");
        }
    } else if (item.realPlatform == "PT004") {
        // outsystems
        // 执行日志接口
        //addDigitalEmpLogsApi({
        //    PubID: item.Id,
        //    UserID: proxy.$store.state.userID,
        //    Type: "1",
        // });
        addJobsLocal(
            item.ProcessID,
            item.ProcessName,
            item.localAppPath,
            item.localAppType,
            item.localExeFile,
            item.localExeParam
        );
        window.open(item.otherPlatform, "_blank");
    } else if (item.realPlatform == "PT005" && item.deployType == "平台") {
        // python
        playProcessPython(item.Id, item);
    } else if (
        ["PT005", "PT006"].includes(item.realPlatform) &&
        item.deployType == "本地"
    ) {
        if (item.localAppPath === "") {
            VXETable.modal.message({
                content: "本地应用路径为空！",
                status: "error",
            });
            return;
        }
        execLocalFile(
            item.ProcessID,
            item.ProcessName,
            item.localAppPath,
            item.localAppType,
            item.localExeFile,
            item.localExeParam
        );
    }
};

const setting = (item) => {
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        proxy.$refs.dempSetupRef.showSetting(item);
    } else if (item.realPlatform == "PT005") {
        proxy.$refs.dempPythonSetupRef.showSetting(item);
    } else {
        proxy.$refs.dempotherSetupRef.showSetting(item);
    }
};
const toggleVisible = (item) => {
    item.IsHidden = item.IsHidden == "1" ? "0" : "1";
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        const params = {
            Id: item.Id,
            ProcessID: "",
            ProcessName: "",
            IsHidden: item.IsHidden,
            photo: "",
            seq: 0,
        };

        proxy.$api.jobManageAPI
            .setRobotHidden(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                console.log(res);
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });

        //python
    } else if (item.realPlatform == "PT005") {
        const paramsPython = {
            id: item.Id,
            projectID: "",
            projectName: "",
            IsHidden: item.IsHidden,
            Photo: "",
            seq: 0,
        };
        proxy.$api.jobManageAPI
            .setPythonRobotHidden(Qs.stringify(paramsPython))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                console.log(res);
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};

const log = (item) => {
    if (item.realPlatform == "PT001" || item.realPlatform == "PT002") {
        proxy.$refs.runlogRef.findDataJob(item.ProcessID, item.RobotName, true);
    } else if (item.realPlatform == "PT005" && item.deployType == "平台") {
        proxy.$refs.runlogpythonRef.findDataJob(
            item.ProcessID,
            item.RobotName,
            true
        );
    } else if (item.deployType == "本地") {
        proxy.$refs.runlogLocalRef.findDataJob(item.ProcessID);
    } else {
        VXETable.modal.message({
            content: "该平台暂无执行日志",
            status: "warning",
        });
    }
};

const actions = [
    {
        key: "run",
        title: "执行",
        icon: runIcon,
        jumpIcon: jumpIcon,
        stopIcon: stopIcon,
        runIconLocal: runIconLocal,
        onClick: run,
    },
    {
        key: "setting",
        title: "设置",
        icon: settingIcon,
        onClick: setting,
    },
    {
        key: "delete",
        title: "日志",
        icon: logIcon,
        onClick: log,
    },
];

const clickTitle = () => {
    searchFlag.value = false;
    activeClassId.value = null;
    activeClass.value = null;
};

const scrollToSection = (item) => {
    const { sectionId, id, name } = item;
    if (activeClassId.value === id) {
        if (!searchVal.value && !activeClass.value) {
            searchFlag.value = false;
        }
        return; // 如果当前选中的标签已经是该标签，则不执行滚动
    }
    activeClassId.value = id;
    activeClass.value = name;
    if (searchFlag.value) {
        return; // 如果是搜索结果，不滚动到指定区域
    }
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({
            behavior: "smooth", // 平滑滚动
            block: "start", // 滚动到元素顶部
        });
    }
};

// 请求接口getDempListApi
const getDEmpListApi = (fistLoad = false) => {
    console.log("index getDEmpListApi");
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 0,
        pageSize: 10,
        searchKey: ["", "", shareTab.value],
    };
    proxy.$api.dEmpAPI.getDEmpList(Qs.stringify(params)).then((res) => {
        console.log("getDEmpListApi", res.data.Data);
        if (res.data.Success) {
            loading.value = false;
            state.allData = res.data.Data;
            state.classTypes = Object.entries(state.allData.dataTable).map(
                ([key, value], index) => ({
                    name: key,
                    id: index + 1,
                    sectionId: `section${index + 1}`,
                })
            );
        }
    });
};
getDEmpListApi(true); // Todo:dd

let timer = null;
const setTimer = () => {
    timer = setInterval(() => {
        getDEmpListApi();
    }, 1000 * 10);
};
const clearTimer = () => {
    clearInterval(timer);
    timer = null;
};
const cleanup = {
    scrollEl: null,
    scrollHandler: null,
};
watch(searchFlag, (newVal, oldVal) => {
    console.log("变了：", oldVal, "=>", newVal);
    if (newVal) {
        clearTimer();
    } else {
        setTimer();
    }
});
onMounted(() => {
    setTimer();
    // 监听滚动
    const el = document.querySelector(".app-layout__page");
    if (!el) {
        return;
    }

    const handler = () => {
        showBackTop.value = el.scrollTop > 300;
    };

    el.addEventListener("scroll", handler);

    // ===== 保存引用 方便解绑 =====
    cleanup.scrollEl = el;
    cleanup.scrollHandler = handler;
});

// 清理 timer
onUnmounted(() => {
    if (timer) {
        console.log("index清除定时器");

        clearTimer();
    }
    // 解绑滚动事件
    if (cleanup.scrollEl && cleanup.scrollHandler) {
        cleanup.scrollEl.removeEventListener("scroll", cleanup.scrollHandler);
    }
});
</script>

<style lang="scss" scoped>
@import "cardcss.scss";

.share-type-group {
    .ant-btn {
        min-width: 80px;
        border-radius: 4px;
        min-height: 32px;
        color: #000000 !important;
        background: #ffffff !important;
        border-color: #d9d9d9 !important;
    }

    .ant-btn:hover,
    .ant-btn:focus {
        color: #000000 !important;
        background: #ffffff !important;
        border-color: #d9d9d9 !important;
    }

    .share-btn-active {
        background: #1890ff !important;
        color: #ffffff !important;
        border-color: #1890ff !important;
        box-shadow: none !important;
    }

    .share-btn-active:hover,
    .share-btn-active:focus {
        background: #40a9ff !important;
        color: #ffffff !important;
        border-color: #40a9ff !important;
    }
}
.bottom-item.bottom-item-active-search {
    background-color: #722ed1 !important;
    color: #fff !important;
    border-color: #722ed1 !important;
    font-weight: bold;
}

.bottom-item.bottom-item-active-search:hover {
    background-color: #9254de !important;
    border-color: #9254de !important;
}
</style>
